// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__Eh203","logoholder":"style_logoholder__Mg41p"};